import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import FormBuilder from '../../../../common/form-builder/FormBuilder';
import { usePermission } from '../../../../../contexts/PermissionContext';
import HelpIcon from '../../../../common/help-icon/HelpIcon';
import FormField from '../../../../common/form-field/FormField';

export default function STSConfigForm(
  props: Readonly<{
    buId: string;
  }>
) {
  const { t } = useTranslation();
  const { findFeature } = usePermission();
  const { control } = useFormContext();
  const { buId } = props;
  const stsFormConfig = [
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'proximityPeriod',
      label: t('labels.proximityPeriod'),
      control: control,
      fieldType: 'number',
      isRequired: true,
      id: 'proximityPeriod',
      showHelpIcon: true,
      allowDecimal: true,
      helpText: t('toast.proximityPeriodDesc'),
      disabled: buId
        ? !findFeature('BUCompanyConfiguration.EditSTSConfigurationSettings')
        : !findFeature('CompanyConfiguration.EditSTSConfigurationSettings'),
      maxLength: 100,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'thresholdPeriod',
      label: t('labels.thresholdPeriod'),
      control: control,
      fieldType: 'number',
      isRequired: true,
      id: 'thresholdPeriod',
      showHelpIcon: true,
      helpText: t('toast.thresholdPeriodDesc'),
      maxLength: 100,
      disabled: buId
        ? !findFeature('BUCompanyConfiguration.EditSTSConfigurationSettings')
        : !findFeature('CompanyConfiguration.EditSTSConfigurationSettings'),
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'maximumSpeedDuringSTS',
      label: t('labels.maximumSpeedDuringSTS'),
      control: control,
      fieldType: 'number',
      isRequired: true,
      showHelpIcon: true,
      allowDecimal: true,
      id: 'maximumSpeedDuringSTS',
      helpText: t('toast.maximumSpeedDuringSTSDesc'),
      maxLength: 100,
      disabled: buId
        ? !findFeature('BUCompanyConfiguration.EditSTSConfigurationSettings')
        : !findFeature('CompanyConfiguration.EditSTSConfigurationSettings'),
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'vesselContactDistanceThreshold',
      label: t('labels.vesselContactDistanceThreshold'),
      control: control,
      fieldType: 'number',
      id: 'vesselContactDistanceThreshold',
      isRequired: true,
      showHelpIcon: true,
      helpText: t('toast.vesselContactDistanceThresholdDesc'),
      maxLength: 100,
      disabled: buId
        ? !findFeature('BUCompanyConfiguration.EditSTSConfigurationSettings')
        : !findFeature('CompanyConfiguration.EditSTSConfigurationSettings'),
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
  ];
  return (
    <div className="row">
      <FormBuilder formConfig={stsFormConfig} />
      <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col ">
        <div className="mb-btm-space m-c-form-group">
          <label className=" m-l-input-label">
            {t('labels.stsRiskRatingLabel')}
            <HelpIcon
              id={'STSriskRating'}
              helpText={t('toast.stsRiskRatingTxt')}
            />
          </label>
        </div>
        <div className="check-box-ais-gap-risk-rating">
          <Controller
            name={'IsSTSLowRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'low',
                  label: t('labels.low'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'low',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
          <Controller
            name={'IsSTSMediumRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'medium',
                  label: t('labels.medium'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'medium',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
          <Controller
            name={'IsSTShighRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'high',
                  label: t('labels.high'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'high',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
